import React from "react";

const HomePage = React.lazy(() => import("../pages/HomePage"));
const AboutPage = React.lazy(() => import("../pages/AboutPage"));
const SolutionPage = React.lazy(() => import("../pages/SolutionPage"));
const PortfolioPage = React.lazy(() => import("../pages/PortfolioPage"));
const PortfolioDetailPage = React.lazy(() =>
  import("../pages/PortfolioDetailPage")
);
const NewsPage = React.lazy(() => import("../pages/NewsPage"));
const NewsDetailPage = React.lazy(() => import("../pages/NewsDetailPage"));
const ContactPage = React.lazy(() => import("../pages/ContactPage"));
const PrivacyPage = React.lazy(() => import("../pages/PrivacyPage"));

const routes = [
  { path: "/", exact: true, name: "Home", element: HomePage },
  { path: "/about", name: "About", element: AboutPage },
  { path: "/solution", name: "Solution", element: SolutionPage },
  { path: "/aigc-work", name: "Portfolio", element: PortfolioPage },
  {
    path: "/aigc-work/:id",
    name: "PortfolioDetail",
    element: PortfolioDetailPage,
  },
  // { path: "/news", name: "News", element: NewsPage },
  { path: "/news/:id", name: "NewsDetail", element: NewsDetailPage },
  { path: "/privacy", name: "Privacy", element: PrivacyPage },
  { path: "/contact", name: "Contact", element: ContactPage },
];

export default routes;
